import { theme } from '../../../../../../core/theme/theme';

export const MapTilesTabsStyles = (isPicked?: boolean) => {
    return {
        TabsHolder: {
            position: 'absolute',
            display: 'flex',
            flexDirection: 'row-reverse',
            top: '10px',
            left: '50%',
            padding: 0,
            transform: 'translate(-50%)',
            gap: 1,
            zIndex: 2001,
        } as const,
        Tab: {
            display: 'flex',
            flexDirection: 'column',
            // width: '100px',
        } as const,
        DropdownOptions: {
            display: isPicked ? 'block' : 'none',
            border: '1px solid silver',
            backgroundColor: theme.colors.default,
            fontSize: '11px',
            fontFamily: theme.fonts.default,
            textAlign: 'center',
            paddingTop: 4,
            paddingBottom: 4,
            cursor: 'pointer',
        } as const,
    };
};
